import { useApiUrl } from '../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../global/network/useCampfireFetch';

interface SendFormSubmissionEmailParams {
  formSubmissionId: string;
  subject: string;
  body: string;
  replyTo?: string | null;
  cc?: string[];
  bcc?: string[];
}

export const useSendFormSubmissionEmail = () => {
  const apiUrl = useApiUrl();
  const { run, isLoading, error } = useCampfireFetch<{ success: boolean }>({
    defer: true,
  });

  const send = async (params: SendFormSubmissionEmailParams) => {
    return run({
      url: `${apiUrl}/vm/form/submission/send-email`,
      method: 'POST',
      data: params,
    });
  };

  return {
    send,
    isLoading,
    error,
  };
};
